import Vue from 'vue'
import VueRouter from 'vue-router'
import IndexView from '@/views/IndexView.vue'

Vue.use(VueRouter)

/**
 * @param routes 路由组
 */
const routes = [
  //首页
  {
    path: "/",
    name: "index",
    component: IndexView
  },

  //新闻
  {
    path: "/news",
    name: "news",
    component: () => import("@/views/NewsView.vue")
  },

  //医师
  {
    path: "/doctor",
    name: "doctor",
    component: () => import("@/views/DoctorView.vue")
  },

  //治疗
  {
    path: "/techno",
    name: "techno",
    component: () => import("@/views/TechnoView.vue")
  },

  //热点
  {
    path: "/follow",
    name: "follow",
    component: () => import("@/views/FollowView.vue")
  },

  //地址
  {
    path: "/address",
    name: "address",
    component: () => import("@/views/AddresView.vue")
  },

  //简介
  {
    path: "/abstract",
    name: "abstract",
    component: () => import("@/views/AbstractView.vue")
  },

  //详情
  {
    path: "/detaile",
    name: "detaile",
    component: () => import("@/views/DetaileView.vue")
  }
]

const router = new VueRouter({
  routes
})

export default router
